export const blockIconsBusinessandpaymentsDomainNew = (
	<span className='material-symbols-outlined'>domain</span>
);
